import { StyledButton } from "components/button.styles";
import Col from "components/grid/col";
import Row from "components/grid/row";
import styled from "@emotion/styled";
import { css } from "@emotion/react";

export const StyledRow = styled(Row)`
  padding-top: 2rem;
`;

interface ColProps {
  $align: "left" | "right" | "full";
}

export const StyledCol = styled(Col)<ColProps>`
  ${(props) => props.$align === "left" && css``};

  ${(props) =>
    props.$align === "right" &&
    css`
      justify-content: right;
    `};

  ${(props) =>
    props.$align === "full" &&
    css`
      & > ${StyledButton} {
        flex: 1;
      }
    `};
`;
